export default __webpack_public_path__ + "images/Clementine_Lille_04_2024.0fadd3b5.png";